import PageIntro from '../components/PageIntro';

export default function RefundPolicy() {
  return (
    <div className="page-shell space-y-8">
      <PageIntro
        eyebrow="Refunds"
        title="A refund policy that feels clear, calm, and consistent with the rest of the site."
        description="This page keeps refund guidance readable while still fitting the broader visual direction of Victoria's Place."
      />

      <section className="section-card-strong p-8">
        <div className="legal-stack">
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Donations</h2>
            <p className="section-copy text-base">
              Donations are generally non-refundable. If you believe a mistake has been made or
              there are special circumstances, contact the organization within 30 days.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Event tickets</h2>
            <p className="section-copy text-base">
              Ticket refund availability may vary by event and circumstance. Questions should be sent
              as early as possible.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Processing refunds</h2>
            <p className="section-copy text-base">
              Approved refunds are typically returned to the original payment method within 5 to 10
              business days.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Contact us</h2>
            <p className="section-copy text-base">
              Use the contact page if you need to request a refund or clarify the policy.
            </p>
          </article>
        </div>

        <p className="mt-8 text-sm font-medium text-slate-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>
    </div>
  );
}
